import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { LoaderService } from 'app/shared/services/loader.service';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';

@Component({
    selector: 'app-generic-check-box',
    templateUrl: './generic-check-box.component.html',
    styleUrls: ['./generic-check-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericCheckBoxComponent implements OnInit {
  @Input() filter: InternalFilterGroup;

  loaderId = UtilityFunctions.newGuid();
  searchSettings: SearchSettings = {
    placeholder: 'Search name...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [];
  constructor(private loaderService: LoaderService,) { }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.filter) {
      if (!this.cacheFilterData) {
        this.cacheFilterData = UtilityFunctions.DeepClone(this.filter.data);
        this.totalCount = this.cacheFilterData.length;
        this.setDataToView(0);
      }
    }
  }

  ngOnInit(): void {
  }

  onSearch(search: string) {
    this.loaderService.showLoader(this.loaderId);
    this.searchValue = search;
    this.setDataToView(0);
  }

  setDataToView(startSlice: number) {
    const dataToSlice = this.cacheFilterData.filter(element => {
      let isMatch = true;
      if (this.searchValue) {
        const search = this.searchValue.toLowerCase();
        isMatch = element.text?.toLowerCase().indexOf(search) >= 0;
      }
      // More filters
      return isMatch;
    });
    if (this.filter.withPagination) {
      const dataToView = dataToSlice.slice(startSlice, startSlice + 10);
      this.dataToView = dataToView;
    } else {
      this.dataToView = dataToSlice;
    }
    this.loaderService.dismissLoader(this.loaderId);
  }

  getNextData(skipCount: number) {
    if (this.cacheFilterData.length > skipCount) {
      this.loaderService.showLoader(this.loaderId);
      this.setDataToView(skipCount);
    }
  }

}
